 
// import { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import Navbar from "../components/Navbar";
// import { differenceInDays } from "date-fns";

// function BorrowSummary() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [item, setItem] = useState(null);
//   const [loading, setLoading] = useState(false);
  
//   const today = new Date().toISOString().split("T")[0];
//   const [startDate, setStartDate] = useState(today);
//   const [endDate, setEndDate] = useState("");

//   useEffect(() => {
//     const fetchItem = async () => {
//       try {
//         const res = await fetch(`https://borrowhub-backend.onrender.com/api/items/${id}`);
//         const data = await res.json();
//         setItem(data.item);
//       } catch (err) { console.error("Error fetching item:", err); }
//     };
//     fetchItem();
//   }, [id]);

//   // ---------------------------------------------------------
//   // 🚀 REAL RAZORPAY PAYMENT LOGIC (No UI Change)
//   // ---------------------------------------------------------
//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = "https://checkout.razorpay.com/v1/checkout.js";
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const handleRealPayment = async () => {
//     if (!startDate || !endDate) return alert("Please select dates first! 📅");
//     setLoading(true);

//     try {
//       const token = localStorage.getItem("token");
//       const user = JSON.parse(localStorage.getItem("user"));
//       const isScriptLoaded = await loadRazorpayScript();

//       if (!isScriptLoaded) {
//         alert("Razorpay SDK failed to load. Are you online?");
//         setLoading(false);
//         return;
//       }

//       // 1. Create Order/Mandate in Backend
//       const orderRes = await fetch("https://borrowhub-backend.onrender.com/api/payment/create-order", {
//         method: "POST",
//         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//         body: JSON.stringify({ itemId: item._id, days: rentalDays }),
//       });
      
//       const orderData = await orderRes.json();
//       if (!orderData.success) {
//         alert("Order Creation Failed: " + orderData.message);
//         setLoading(false);
//         return;
//       }

//       // 2. Open Razorpay Popup
//       const options = {
//         key: "rzp_test_S4vLys68Pz25pF", // 🔥 Teri asli Test Key
//         subscription_id: orderData.subscriptionId, 
//         name: "BorrowHub",
//         description: `Rent: ${item.title} (Security Mandate)`,
//         //image: "/logo.png",
//         handler: async function (response) {
//           // 3. Verify Payment & Start 5-Min Timer in Backend
//           try {
//             const verifyRes = await fetch("https://borrowhub-backend.onrender.com/api/payment/verify", {
//               method: "POST",
//               headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//               body: JSON.stringify({
//                 razorpay_payment_id: response.razorpay_payment_id,
//                 razorpay_subscription_id: response.razorpay_subscription_id,
//                 razorpay_signature: response.razorpay_signature,
//                 itemId: item._id,
//                 startDate,
//                 endDate,
//                 days: rentalDays,
//                 rentAmount,
//                 platformFee
//               }),
//             });

//             const verifyData = await verifyRes.json();
            
//             if (verifyData.success) {
//                navigate("/my-items", { 
//                  state: { 
//                    newOrder: true, 
//                    pickupOtp: verifyData.pickupOtp, 
//                    itemName: item.title,
//                    itemImage: item.images?.find(img => img.isCover)?.url || item.images?.[0]?.url,
//                    borrowId: verifyData.borrowId 
//                  } 
//                });
//             } else { alert("Payment Verification Failed!"); }
//           } catch (err) { alert("Server Error during verification"); }
//         },
//         prefill: {
//           name: user?.name || "",
//           email: user?.email || "",
//           contact: user?.phone || "",
//         },
//         theme: { color: "#16a34a" },
//         modal: { ondismiss: () => setLoading(false) }
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
      
//     } catch (err) {
//       console.error(err);
//       alert("Something went wrong!");
//       setLoading(false);
//     }
//   };

//   // 🔐 Loading State
//   if (!item) return (
//      <>
//        <Navbar />
//        <div className="text-center mt-5"><div className="spinner-border text-success" /></div>
//      </>
//   );

//   // ✅ Calculations
//   const dailyRate = Number(item.pricePerDay) || 0;
//   const rentalDays = startDate && endDate ? Math.max(1, differenceInDays(new Date(endDate), new Date(startDate))) : 1;
//   const rentAmount = dailyRate * rentalDays;
//   const platformFee = Math.round(rentAmount * 0.05);
//   const totalPayable = rentAmount + platformFee;

//   return (
//     <>
//       <Navbar /> 
//       <div className="container my-4">
        
//         {/* 🔙 Header */}
//         <div className="d-flex align-items-center mb-3">
//           <button className="btn btn-light me-2" onClick={() => navigate(-1)}>← Back</button>
//           <h4 className="mb-0 fw-semibold">Borrow Summary</h4>
//         </div>

//         {/* 🔹 SECTION 1: ITEM SNAPSHOT */}
//         <div className="card mb-3 shadow-sm">
//           <div className="card-body d-flex gap-3">
//             <div style={{ width: "80px", height: "80px", borderRadius: "8px", overflow: "hidden", background: "#f5f5f5" }}>
//               <img src={item.images?.find((i) => i.isCover)?.url} alt={item.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//             </div>
//             <div className="flex-grow-1">
//               <h5 className="fw-bold mb-1">{item.title}</h5>
//               <span className="badge bg-success mb-2">{item.category}</span>
//               <div className="text-muted small mb-1">👤 {item.owner?.name} &nbsp; ⭐ {item.owner?.rating || "4.5"}</div>
//               <div className="text-muted small">📍 {item.location?.city}</div>
//             </div>
//           </div>
//         </div>

//         {/* 🔹 SECTION 2: DETAILS */}
//         <div className="card mb-3 shadow-sm">
//           <div className="card-body">
//             <h6 className="fw-semibold mb-2">Item Details</h6>
//             <p className="mb-1"><strong>Condition:</strong> {item.condition}</p>
//             <p className="mb-2"><strong>Description:</strong> {item.description}</p>
//           </div>
//         </div>

//         {/* 📅 SECTION 3: CALENDAR */}
//         <div className="card mb-3 shadow-sm">
//             <div className="card-body">
//                 <h6 className="fw-semibold mb-2">Select Dates</h6>
//                 <label className="small text-muted fw-bold">Start Date (Today)</label>
//                 <input type="date" className="form-control bg-light" value={startDate} readOnly />
//                 <label className="small text-muted fw-bold mt-2">End Date</label>
//                 <input type="date" className="form-control" value={endDate} min={startDate} required onChange={(e) => setEndDate(e.target.value)} />
//             </div>
//         </div>

//         {/* 🔹 SECTION 4: PAYMENT ACTION */}
//         <div className="card shadow-sm mt-3">
//           <div className="card-body">
//             <h5 className="text-success">₹{dailyRate} <small>/ day</small></h5>
//             <p className="text-muted mb-1">{rentalDays} days × ₹{dailyRate} = ₹{rentAmount}</p> 
// //            { <p className="text-muted mb-1">Platform Fee (5%): ₹{platformFee}</p>}
            
//             <hr />
//             <h6 className="fw-bold mb-3">Total Payable: ₹{totalPayable}</h6>

//             {/* 🔥 TERA ORIGINAL YELLOW BUTTON (With Real Logic inside) */}
//             <button className="btn btn-warning w-100 py-2" onClick={handleRealPayment} disabled={loading}>
//               <div className="d-flex flex-column align-items-center">
//                 <span className="fw-bold text-uppercase">
//                     {loading ? "Processing..." : "💵 Pay Now & Authorize Limit"}
//                 </span>
//                 <span className="small text-dark opacity-75 mt-1" style={{ fontSize: "0.7rem", lineHeight: "1.2" }}>
//                    ⚠️ Note: Rent will be deducted. Security limit authorized.
//                 </span>
//               </div>
//             </button>

//           </div>
//         </div>

//       </div>
//     </>
//   );
// }

// export default BorrowSummary;

import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { differenceInDays } from "date-fns";

function BorrowSummary() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const today = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const fetchItem = async () => {
      try {
        const res = await fetch(`https://borrowhub-backend.onrender.com/api/items/${id}`);
        const data = await res.json();
        setItem(data.item);
      } catch (err) { console.error("Error fetching item:", err); }
    };
    fetchItem();
  }, [id]);

  // ---------------------------------------------------------
  // 🚀 REAL RAZORPAY PAYMENT LOGIC (No UI Change)
  // ---------------------------------------------------------
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleRealPayment = async () => {
    if (!startDate || !endDate) return alert("Please select dates first! 📅");
    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));
      const isScriptLoaded = await loadRazorpayScript();

      if (!isScriptLoaded) {
        alert("Razorpay SDK failed to load. Are you online?");
        setLoading(false);
        return;
      }

      // 1. Create Order/Mandate in Backend
      const orderRes = await fetch("https://borrowhub-backend.onrender.com/api/payment/create-order", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ itemId: item._id, days: rentalDays }),
      });
      
      const orderData = await orderRes.json();
      if (!orderData.success) {
        alert("Order Creation Failed: " + orderData.message);
        setLoading(false);
        return;
      }

      // 2. Open Razorpay Popup
      const options = {
        key: "rzp_test_S4vLys68Pz25pF", // 🔥 Teri asli Test Key
        subscription_id: orderData.subscriptionId, 
        name: "BorrowHub",
        description: `Rent: ${item.title} (Security Mandate)`,
        //image: "/logo.png",
        handler: async function (response) {
          // 3. Verify Payment & Start 5-Min Timer in Backend
          try {
            const verifyRes = await fetch("https://borrowhub-backend.onrender.com/api/payment/verify", {
              method: "POST",
              headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
              body: JSON.stringify({
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_subscription_id: response.razorpay_subscription_id,
                razorpay_signature: response.razorpay_signature,
                itemId: item._id,
                startDate,
                endDate,
                days: rentalDays,
                rentAmount,
                platformFee
              }),
            });

            const verifyData = await verifyRes.json();
            
            if (verifyData.success) {
               navigate("/my-items", { 
                 state: { 
                   newOrder: true, 
                   pickupOtp: verifyData.pickupOtp, 
                   itemName: item.title,
                   itemImage: item.images?.find(img => img.isCover)?.url || item.images?.[0]?.url,
                   borrowId: verifyData.borrowId 
                 } 
               });
            } else { alert("Payment Verification Failed!"); }
          } catch (err) { alert("Server Error during verification"); }
        },
        prefill: {
          name: user?.name || "",
          email: user?.email || "",
          contact: user?.phone || "",
        },
        theme: { color: "#16a34a" },
        modal: { ondismiss: () => setLoading(false) }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
      
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
      setLoading(false);
    }
  };

  // 🔐 Loading State
  if (!item) return (
     <>
       <Navbar />
       <div className="text-center mt-5"><div className="spinner-border text-success" /></div>
     </>
  );

  // ✅ Calculations
  const dailyRate = Number(item.pricePerDay) || 0;
  const rentalDays = startDate && endDate ? Math.max(1, differenceInDays(new Date(endDate), new Date(startDate))) : 1;
  const rentAmount = dailyRate * rentalDays;
  const platformFee = Math.round(rentAmount * 0.05);
  const totalPayable = rentAmount + platformFee;

  return (
    <>
      <Navbar /> 
      <div className="container my-4">
        
        {/* 🔙 Header */}
        <div className="d-flex align-items-center mb-3">
          <button className="btn btn-light me-2 shadow-sm" onClick={() => navigate(-1)}>← Back</button>
          <h4 className="mb-0 fw-bold">Checkout Summary</h4>
        </div>

        {/* 🔹 SECTION 1: ITEM SNAPSHOT */}
        <div className="card mb-3 shadow-sm border-0">
          <div className="card-body d-flex gap-3 align-items-center">
            <div style={{ width: "80px", height: "80px", borderRadius: "8px", overflow: "hidden", background: "#f5f5f5" }}>
              <img src={item.images?.find((i) => i.isCover)?.url || item.images?.[0]?.url} alt={item.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            </div>
            <div className="flex-grow-1">
              <h5 className="fw-bold mb-1 text-dark text-truncate" style={{maxWidth: "200px"}}>{item.title}</h5>
              <span className="badge bg-success mb-2 px-2 py-1">{item.category}</span>
              <div className="text-muted small">👤 {item.owner?.name} &nbsp; ⭐ {item.owner?.rating || "4.5"}</div>
            </div>
          </div>
        </div>

        {/* 📅 SECTION 2: CALENDAR */}
        <div className="card mb-3 shadow-sm border-0">
            <div className="card-body">
                <h6 className="fw-bold mb-3 text-dark">Select Rental Dates</h6>
                <div className="row g-2">
                  <div className="col-6">
                    <label className="small text-muted fw-bold">Start Date</label>
                    <input type="date" className="form-control bg-light border-0 shadow-none" value={startDate} readOnly />
                  </div>
                  <div className="col-6">
                    <label className="small text-muted fw-bold">End Date</label>
                    <input type="date" className="form-control border-secondary" value={endDate} min={startDate} required onChange={(e) => setEndDate(e.target.value)} />
                  </div>
                </div>
            </div>
        </div>

        {/* 🔹 SECTION 3: PAYMENT ACTION & TRUST BOX */}
        <div className="card shadow-sm mt-3 border-0 bg-white">
          <div className="card-body">
            
            {/* Payment Breakdown */}
            <div className="mb-3">
              <h5 className="text-success fw-bold mb-3">₹{dailyRate} <small className="text-muted" style={{fontSize:"14px"}}>/ day</small></h5>
              
              <div className="d-flex justify-content-between text-muted mb-2" style={{ fontSize: "14px" }}>
                <span>Rent ({rentalDays} Days)</span>
                <span className="fw-bold text-dark">₹{rentAmount}</span>
              </div>
              
              <div className="d-flex justify-content-between text-muted border-bottom pb-2 mb-2" style={{ fontSize: "14px" }}>
                <span>Platform Fee (5%)</span>
                <span className="fw-bold text-dark">₹{platformFee}</span>
              </div>
              
              <div className="d-flex justify-content-between align-items-center mt-2">
                <span className="fw-bold text-dark fs-6">Total Payable Now</span>
                <span className="text-primary fw-bold fs-5">₹{totalPayable}</span>
              </div>
            </div>

            {/* 🔥 TERA ORIGINAL YELLOW BUTTON */}
            <button className="btn btn-warning w-100 py-2 shadow-sm rounded-3 mb-3" onClick={handleRealPayment} disabled={loading}>
              <div className="d-flex flex-column align-items-center">
                <span className="fw-bold text-uppercase fs-6">
                    {loading ? "Processing..." : "💵 Pay Now & Authorize Limit"}
                </span>
              </div>
            </button>

           {/* 🛡️ E-MANDATE TRUST BOX */}
<div className="alert p-3 rounded-3" style={{ fontSize: "12px", border: "1px solid #bae6fd", backgroundColor: "#f0f9ff" }}>
  <div className="d-flex align-items-center mb-2">
    <span className="fs-5 me-2">🛡️</span>
    <strong className="text-dark" style={{fontSize: "13px"}}>Zero-Deduction Security Hold</strong>
  </div>
  <p className="mb-2 text-secondary" style={{ lineHeight: "1.4" }}>
    {/* 🔥 Yahan se 10000 hata diya! Ab wahi dikhega jo owner ne set kiya hai */}
    To secure this item, a temporary hold of <b className="text-dark">₹{item?.deposit || 0}</b> will be authorized on your card/bank. 
    <span className="text-success fw-bold"> No money will be deducted for this hold today.</span>
  </p>
  <ul className="mb-0 ps-3 text-secondary" style={{ fontSize: "11px", lineHeight: "1.5" }}>
    <li>Your funds remain safe in your account.</li>
    <li>Hold cancels automatically upon safe return.</li>
    <li>Charges apply ONLY in cases of severe damage or theft.</li>
  </ul>
</div>

            {/* Offline Settlement Disclaimer */}
            <div className="text-muted mt-2 text-center fst-italic" style={{ fontSize: "10px" }}>
              *If the owner requires any extra physical security deposit, please settle it offline during pickup.
            </div>

          </div>
        </div>

      </div>
    </>
  );
}

export default BorrowSummary;